export const PAGINATION_LIMIT = 200;

export const ApplistMapping = {
  BundleId: 'Mobile App',
  Domain: 'Site',
  ConnectedTVId: 'Connected TV App',
  DoohBoardId: 'Digital Out-of-Home Board',
}
